const {
    VUE_APP_DEFAULT_LANGUAGE,
    VUE_APP_API_BASE_URL,
    NODE_ENV = ''
} = process.env;

const environment = NODE_ENV.toLowerCase();
const apiBaseUrl = VUE_APP_API_BASE_URL;

const defaultLanguage = VUE_APP_DEFAULT_LANGUAGE;

const VUE_APP_UI_URL = process.env.NODE_ENV === "production" ? "/msg" : "";


export { environment, apiBaseUrl, defaultLanguage, VUE_APP_UI_URL };